module.exports = __webpack_public_path__ + "img/5.14412379.png";